const formsExceptAddressTypes = [
  {
    name: 'login',
    isLoggedIn: false,
    isLoggedOut: false
  },
  {
    name: 'common',
    isLoggedIn: true,
    isLoggedOut: true
  },
  {
    name: 'modules',
    isLoggedIn: true,
    isLoggedOut: false,
    isAdmin: true
  },
  {
    name: 'newPassword',
    isLoggedIn: true,
    isLoggedOut: true
  }
]
const preventFieldForRegistration = ['validFrom', 'validTo']

/**
 get all forms for a logged in user. After common we should have
 the addressTypes
*/
function getLoggedInForms(addressTypes, helper) {
  let forms = formsExceptAddressTypes.reduce((acc, form, index) => {
    if (index === 2) {
      addressTypes.forEach(addressType => {
        acc.push(addressType)
      })
    }
    if (form.isLoggedIn) {
      if (form.isAdmin) {
        if (helper.isAdmin) {
          acc.push(form.name)
        }
      } else {
        acc.push(form.name)
      }
    }

    return acc
  }, [])

  return forms
}

function shouldValidateFormForRegistration(formName) {
  return formsExceptAddressTypes.reduce((value, form) => {
    if (form.name === formName && !form.isLoggedOut) {
      value = false
    }
    return value
  }, true)
}

function shouldValidateFormForUser(formName) {
  return formsExceptAddressTypes.reduce((value, form) => {
    if (form.name === formName && !form.isLoggedIn) {
      value = false
    }
    return value
  }, true)
}

export {
  getLoggedInForms,
  preventFieldForRegistration,
  shouldValidateFormForRegistration,
  shouldValidateFormForUser
}



// WEBPACK FOOTER //
// ./src/modules/user/helpers/formHelper.js